import type {RouteRecordRaw} from "vue-router";

export const routeName = 'DraftList';

export const route: RouteRecordRaw = {
    name: routeName,
    path: '',
    component: () => import('@/pages/DraftList'),
    meta: {
        isHide: true,
    }
};
